'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _intersperse = require('linksoft/utils/intersperse');

var _intersperse2 = _interopRequireDefault(_intersperse);

var _lazyImage = require('linksoft/initializers/lazy-image');

var _lazyImage2 = _interopRequireDefault(_lazyImage);

var _actions = require('../../../actions');

var _actions2 = _interopRequireDefault(_actions);

var _AuthorLink = require('./AuthorLink');

var _AuthorLink2 = _interopRequireDefault(_AuthorLink);

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = {
    updateFreeProducts: _actions2.default.updateFreeProducts
};

var FreeProductItem = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
    (0, _inherits3.default)(FreeProductItem, _React$PureComponent);

    function FreeProductItem() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FreeProductItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FreeProductItem.__proto__ || (0, _getPrototypeOf2.default)(FreeProductItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleDelete = function () {
            _this.props.updateFreeProducts(null, _this.props.id);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FreeProductItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _lazyImage2.default)();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                productName = _props.productName,
                authors = _props.authors,
                url = _props.url,
                thumbnailUrl = _props.thumbnailUrl;

            var distinctAuthors = _utils2.default.distinctByParam(authors, 'id');
            return _react2.default.createElement(
                'div',
                { className: 'cart__item cart__item--product cart__item--free cart-i' },
                _react2.default.createElement(
                    'div',
                    { className: 'cart-i__first' },
                    _react2.default.createElement(
                        'a',
                        { href: url, className: 'cart-i__cover' },
                        _react2.default.createElement('img', { 'data-src': thumbnailUrl, alt: '' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cart-i__infos' },
                        _react2.default.createElement(
                            'a',
                            { href: url, className: 'cart-i__title' },
                            productName
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-i__authors' },
                            (0, _intersperse2.default)((distinctAuthors || []).map(function (author) {
                                return _react2.default.createElement(_AuthorLink2.default, (0, _extends3.default)({ key: author.id }, author));
                            }), ', ')
                        ),
                        _react2.default.createElement('div', { className: 'cart-i__price' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cart-i__last' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart-i__summary' },
                        _react2.default.createElement('i', { className: 'icon--gift red' })
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn__square cart-i__remove', onClick: this.handleDelete },
                        _react2.default.createElement('i', { className: 'icon--cross' })
                    )
                )
            );
        }
    }]);
    return FreeProductItem;
}(_react2.default.PureComponent)) || _class);
exports.default = FreeProductItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/FreeProductItem.js
// module id = 1018
// module chunks = 0